export const showCartMessage = ({ websockets }) =>
  websockets.showCartUpdateMessage;
